<template>
  <div>
    <flash-messages/>
    <div class="px-4 py-2 bg-gray-700">
      <img src="/images/logo.png" class="h-12 mx-auto" alt="Casa Auto">
    </div>

    <div class="p-2">

      <div class="mb-2" v-if="mediaFiles.length">
        <div v-for="media in mediaFiles" :key="media.id" class="mb-2">
          <img v-if="media.collection_name === 'images'" :src="media.url" alt="" class="object-contain w-full h-56 bg-black"/>

          <video v-if="media.collection_name === 'videos'" class="object-contain w-full h-56 bg-black" controls>
            <source :src="media.url" type="video/webm">
            <source :src="media.url_mp4" type="video/mp4">
          </video>
        </div>
      </div>

      <div v-if="operations.length">
        <div
            class="p-4 my-4 bg-white rounded shadow"
            :class="{'border-2 border-red-600': validationError(`operations.${index}.status`)}"
            v-for="(operation, index) in operations"
            :key="operation.id"
            :ref="`operation-${operation.id}`">
          <div>
            <h2 class="font-semibold">{{ operation.description }}</h2>

            <div class="mt-4">
              <div class="flex justify-between">
                <div>{{ __('Work price') }}</div>
                <div>{{ operation.price }} RON</div>
              </div>
            </div>

            <div class="p-2 mt-4 text-sm italic font-medium leading-normal bg-orange-100 rounded" v-if="operation.observations">
              {{ operation.observations }}
            </div>
          </div>

          <div class="flex justify-between mt-8">
            <button class="h-10 px-4 font-semibold border-4 border-red-500 rounded-md"
                    @click="refuse(operation)"
                    :disabled="request.responded_at"
                    :class="{
                      'text-white bg-red-500': operation.status === 'refused',
                      'text-red-600': operation.status !== 'refused',
                      'opacity-50': request.responded_at
                    }">
              {{ __('Refuse') }}
            </button>
            <button
                class="h-10 px-4 font-semibold border-4 border-green-500 rounded-md"
                @click="approve(operation)"
                :disabled="request.responded_at"
                :class="{
                  'text-white bg-green-500':operation.status === 'approved',
                  'text-green-600': operation.status !== 'approved',
                  'opacity-50': request.responded_at
                }">
              {{ __('Approve') }}
            </button>
          </div>
        </div>
      </div>

      <div class="p-4 mt-6">
        <div class="mb-4" v-if="operations.length">
          <div class="flex justify-between">
            <div>{{ __('Total') }}</div>
            <div class="font-bold">{{ operationsTotalPrice }} RON</div>
          </div>
          <div class="flex justify-between mt-2">
            <div>{{ __('Total approved') }}:</div>
            <div class="font-bold">{{ approvedOperationsTotalPrice }} RON</div>
          </div>
          <div class="mt-4 text-xs">{{ __('Prices include VAT') }}</div>
        </div>

        <button class="w-full h-12 px-4 font-semibold text-white rounded-md bg-coral-400" @click="submit()" v-if="!request.responded_at">
          {{ __('Agree and send to dealer') }}
        </button>

        <div class="w-full py-5 text-center" v-if="request.responded_at">
          {{ __('Response sent on :date', {date: request.responded_at}) }}
        </div>

      </div>
    </div>
  </div>
</template>


<script>
import Icon from '@/Shared/Icon';
import FlashMessages from '@/Shared/FlashMessages';

export default {
  metaInfo() {
    return {
      title: this.__('Order notifications'),
    };
  },
  props: {
    job: Object,
    request: Object,
  },
  data() {
    return {
      operations: [],
      mediaFiles: [],
    };
  },
  components: {
    Icon,
    FlashMessages,
  },
  mounted() {
    this.operations = this.request.operations;
    this.mediaFiles = this.request.media;
  },
  methods: {
    refuse(operation) {
      operation.status = 'refused';
    },
    approve(operation) {
      operation.status = 'approved';
    },
    submit() {
      let operations = this.operations.map((operation) => {
        return {
          id: operation.id,
          status: operation.status,
        };
      });

      this.$inertia.put(this.route('clientApprovalRequests.update', { approvalRequest: this.request.id, token: this.request.token }),
          {
            operations: operations,
          },
          {
            preserveState: true, preserveScroll: true,
          });
    },
  },
  computed: {
    approvedOperationsTotalPrice() {
      return this.operations.reduce((total, operation) => {
        if (operation.status === 'approved') {
          return total + operation.price;
        }
        return total;
      }, 0);
    },
    operationsTotalPrice() {
      return this.operations.reduce((total, operation) => {
        return total + operation.price;
      }, 0);
    },
  },
};
</script>
